export default __webpack_public_path__ + "bfc0b9dc77b306727a226ade10448d7b.svg";